/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Message livraison sous bouton panier
(function () {
  function injectCartNote() {
    if (document.querySelector('.Cart__ShippingNote')) return;
    var form = document.querySelector('form.Cart--expanded');
    if (!form) return;
    var lang = document.documentElement.lang || '';
    var isFrench = lang.toLowerCase().startsWith('fr');
    var note = document.createElement('p');
    note.className = 'Cart__ShippingNote';
    note.style.cssText = 'margin-top:16px;font-size:12px;color:#666;text-align:center;line-height:1.5;padding:0 16px;';
    note.innerHTML = isFrench
      ? 'Une question ou un problème de livraison (étape suivante), contactez-nous directement : <a href="mailto:contact@bivouak.fr" style="color:inherit;text-decoration:underline;">contact@bivouak.fr</a>'
      : 'Any question or shipping issue (next step), reach out directly to us: <a href="mailto:contact@bivouak.fr" style="color:inherit;text-decoration:underline;">contact@bivouak.fr</a>';
    form.insertAdjacentElement('afterend', note);
  }

  document.addEventListener('DOMContentLoaded', injectCartNote);
  window.addEventListener('load', injectCartNote);
  document.addEventListener('cart:refresh', function () {
    setTimeout(injectCartNote, 500);
  });
})();

// Logo swap noir → blanc quand le header est transparent (en haut de page)
(function () {
  var WHITE_LOGO = 'https://cdn.shopify.com/s/files/1/0795/1017/files/LOGO_BIVOUAK_BLANC-Transparent-2026.png?v=1782228613';
  var BLACK_LOGO = 'https://cdn.shopify.com/s/files/1/0795/1017/files/Logo-Bivouak-noir-transparent-2026.png?v=1782228230';

  function initLogoSwap() {
    var header = document.querySelector('.Header');
    var logo = document.querySelector('.Header__LogoImage--primary');
    if (!header || !logo) return;

    function update() {
      var isTransparent = header.classList.contains('Header--transparent');
      var newSrc = isTransparent ? WHITE_LOGO : BLACK_LOGO;
      logo.src = newSrc;
      logo.srcset = newSrc + ' 1x, ' + newSrc + ' 2x';
    }

    new MutationObserver(update).observe(header, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  document.addEventListener('DOMContentLoaded', initLogoSwap);
  window.addEventListener('load', initLogoSwap);
})();

// Touch swipe to reveal secondary product image on mobile
(function () {
  var SWIPE_THRESHOLD = 30;

  function addDots(wrapper) {
    var container = wrapper.querySelector('.AspectRatio');
    if (!container) return null;
    var dots = document.createElement('div');
    dots.className = 'ProductItem__SwipeDots';
    dots.innerHTML =
      '<span class="ProductItem__SwipeDot ProductItem__SwipeDot--active"></span>' +
      '<span class="ProductItem__SwipeDot"></span>';
    container.appendChild(dots);
    return dots;
  }

  function setDot(dots, index) {
    if (!dots) return;
    Array.prototype.forEach.call(dots.children, function (dot, i) {
      dot.classList.toggle('ProductItem__SwipeDot--active', i === index);
    });
  }

  function initSwipe(container) {
    var wrappers = container.querySelectorAll(
      '.ProductItem__ImageWrapper--withAlternateImage'
    );

    Array.prototype.forEach.call(wrappers, function (wrapper) {
      if (wrapper.dataset.swipeInit) return;
      wrapper.dataset.swipeInit = '1';

      var dots = addDots(wrapper);
      var startX = 0;
      var startY = 0;
      var didSwipe = false;
      var isSwiped = false;

      wrapper.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        didSwipe = false;
      }, { passive: true });

      wrapper.addEventListener('touchmove', function (e) {
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          didSwipe = true;
        }
      }, { passive: true });

      wrapper.addEventListener('touchend', function (e) {
        if (!didSwipe) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (dx < -SWIPE_THRESHOLD && !isSwiped) {
          isSwiped = true;
          wrapper.classList.add('is-swiped');
          setDot(dots, 1);
        } else if (dx > SWIPE_THRESHOLD && isSwiped) {
          isSwiped = false;
          wrapper.classList.remove('is-swiped');
          setDot(dots, 0);
        }
      }, { passive: true });

      // Prevent link navigation when a swipe was detected
      wrapper.addEventListener('click', function (e) {
        if (didSwipe) {
          e.preventDefault();
          didSwipe = false;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSwipe(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initSwipe(e.target);
  });
})();
